module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<ul>\r\n	';
 for(var i = 0; i < len; i++){ var n = Ar[i]; ;
__p += '\r\n	<li class="poi-item-li" data-point="' +
((__t = ( encodeURIComponent(JSON.stringify(n.point)) )) == null ? '' : __t) +
'" data-index="' +
((__t = ( i + 1 )) == null ? '' : __t) +
'">\r\n		<div class="poi-type-item-left-wrap">\r\n			<i class="iconfont icon-location"></i>\r\n			<span>' +
((__t = ( i + 1 )) == null ? '' : __t) +
'</span>\r\n		</div>\r\n		<div class="poi-type-item-right-wrap">\r\n			<p class="title" data-title="' +
((__t = ( n.title )) == null ? '' : __t) +
'">' +
((__t = ( n.title )) == null ? '' : __t) +
' <a href="' +
((__t = ( n.url )) == null ? '' : __t) +
'" target="_blank">详情</a> </p>\r\n			<p class="address">' +
((__t = ( n.address )) == null ? '' : __t) +
'</p>\r\n		</div>\r\n	</li>\r\n	';
 } ;
__p += '\r\n</ul>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/js/hotelDetail/templates/poiTypeTmpl.ejs
// module id = 337
// module chunks = 6